<template>
    <div>
        <NavigationBar></NavigationBar>
        <CreationsMenu></CreationsMenu>
        <ListSetting></ListSetting>
        <FooterView></FooterView>
    </div>
</template>
<script>
import NavigationBar from '@/components/shared/Navigation-bar.vue';
import CreationsMenu from '@/components/Setting/Creations-menu.vue';
import ListSetting from '@/components/Setting/List-setting.vue'
import FooterView from '@/components/shared/Footer/Footer-view.vue';

export default {
    name:'SettingViews',

    components: {
        NavigationBar,
        CreationsMenu,
        ListSetting,
        FooterView
    }
    
}
</script>
<style>
    
</style>